import React, { Component } from "react";

import styles from "./styles.scss";
import * as router from "react-router-redux";
import { connect } from "react-redux";
import { actions } from "./redux";

import CSSModules from "react-css-modules";
import { Button, CircularProgress, Checkbox, FormControlLabel } from "@material-ui/core";

@CSSModules(styles, { allowMultiple: true })
class Import extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showStack: false
		};
	}

	componentWillMount() {
		this._scroll = React.createRef();
		this._scrollto = React.createRef();
		this._inputRef = React.createRef();
	}

	uploadFile(result) {
		this.props.upload(result.target.files[0]);
	}

	scrollToBottom() {
		if (this._scrollto.current) {
			this._scrollto.current.scrollIntoView({ behavior: "instant" });
		}
	}

	componentDidUpdate(oldProps) {
		if (this._scroll.current) {
			if (oldProps.output.length != this.props.output.length) {
				//mew message
				if (
					this._scroll.current.scrollHeight <=
					this._scroll.current.scrollTop + this._scroll.current.clientHeight + 100
				) {
					this.scrollToBottom();
				}
			}
		}
	}

	render() {
		return (
			<div styleName="content">

        <Button variant="raised"
                styleName="switch-button"
                onClick={() => this.props.navigate("/MasterRules/Import")}>
          Switch to Master Import
        </Button>

				<div styleName="console" ref={this._scroll}>
					{this.props.output.map((x, i) => {
						//regex matches any number of whitespace, at start, then %C or %E or %S
						const comment = /^[^\S]*%C/.test(x);
						const error = /^[^\S]*%E/.test(x);
						const stack = /^[^\S]*%S/.test(x);
						const warn = /^[^\S]*%W/.test(x);

						if (stack && !this.state.showStack) {
							return null;
						}

						let prints = x.replace(/^[^\S]*%C|^[^\S]*%E|^[^\S]*%S|^[^\S]*%W/, "").split("\n");

						if (prints.length > 1) {
							//replace newline with <br/>
							prints = prints.map((x, i) => (
								<React.Fragment key={i}>
									{x}
									<br />
								</React.Fragment>
							));
						}

						return (
							<div
								key={i}
								styleName={`line ${
									error
										? "line-error"
										: comment
										? "line-green"
										: stack
										? "line-yellow"
										: warn
										? "line-warn"
										: "line-black"
								}`}
							>
								{prints}
							</div>
						);
					})}
					<div ref={this._scrollto} />
				</div>
				<input
					type="file"
					onChange={s => {
						this.uploadFile(s);
						this._inputRef.current.value = "";
					}}
					ref={this._inputRef}
					style={{ display: "none" }}
				/>

				<div styleName="wraps">
					{this.props.isBusy && <CircularProgress />}

					<FormControlLabel
						control={
							<Checkbox
								checked={this.state.showStack}
								onChange={e => {
									this.setState({ showStack: !this.state.showStack });
								}}
								color="primary"
							/>
						}
						label="Show Stacktrace"
					/>
					<Button variant="raised" onClick={() => this._inputRef.current.click()}>
						Upload Spreadsheet
					</Button>
					<Button variant="raised" onClick={() => this.props.clear()}>
						Clear Console
					</Button>
				</div>
			</div>
		);
	}
}

const bindAction = dispatch => {
	return {
		upload: s => dispatch(actions.upload(s)),
		clear: () => dispatch(actions.clear()),

		navigate: (uri, data) => dispatch(router.push(uri, data)),
		goBack: () => dispatch(router.goBack())
	};
};

const mapStateToProps = state => ({
	output: state.import.output,
	isBusy: state.import.isBusy,
	errors: state.import.errors
});

export default connect(
	mapStateToProps,
	bindAction
)(Import);



// WEBPACK FOOTER //
// ./src/ui/Import/Import.js